export const messages = {
  en: {
    marketBlacklist: {
      search: {
        title: 'Search Conditions',
        personName: 'Please enter person name',
        filter: 'Please enter filter'
      },
      list: {
        title: 'Marketing Blacklist'
      },
      table: {
        personName: 'Person Name',
        filter: 'Filter',
        createTime: 'Create Time',
        remark: 'Remark'
      },
      form: {
        personName: 'Person Name',
        filter: 'Filter',
        remark: 'Remark'
      },
      validate: {
        personName: 'Person name is required',
        personNameMax: 'Person name cannot exceed 64 characters',
        filter: 'Filter is required',
        filterMax: 'Filter cannot exceed 64 characters',
        remark: 'Remark is required',
        remarkMax: 'Remark cannot exceed 512 characters',
        blId: 'ID is required'
      },
      add: {
        title: 'Add Marketing Blacklist',
        success: 'Add successfully'
      },
      edit: {
        title: 'Edit Marketing Blacklist',
        success: 'Edit successfully'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this marketing blacklist?',
        success: 'Delete successfully'
      },
      fetchError: 'Failed to fetch marketing blacklist data'
    }
  },
  zh: {
    marketBlacklist: {
      search: {
        title: '查询条件',
        personName: '请输入用户名称',
        filter: '请输入过滤条件'
      },
      list: {
        title: '营销黑白单'
      },
      table: {
        personName: '用户名称',
        filter: '过滤条件',
        createTime: '创建时间',
        remark: '备注'
      },
      form: {
        personName: '用户名称',
        filter: '过滤条件',
        remark: '备注'
      },
      validate: {
        personName: '用户名称不能为空',
        personNameMax: '用户名称不能超过64个字符',
        filter: '过滤条件不能为空',
        filterMax: '过滤条件不能超过64个字符',
        remark: '备注不能为空',
        remarkMax: '备注不能超过512个字符',
        blId: '编号不能为空'
      },
      add: {
        title: '添加营销黑白单',
        success: '添加成功'
      },
      edit: {
        title: '修改营销黑白单',
        success: '修改成功'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除该营销黑白单吗?',
        success: '删除成功'
      },
fetchError: '获取营销黑白单数据失败'
    }
  },
  'zh-TW': {
    marketBlacklist: {
      search: {
        title: '查詢條件',
        personName: '請輸入用戶名稱',
        filter: '請輸入過濾條件'
      },
      list: {
        title: '營銷黑白單'
      },
      table: {
        personName: '用戶名稱',
        filter: '過濾條件',
        createTime: '創建時間',
        remark: '備註'
      },
      form: {
        personName: '用戶名稱',
        filter: '過濾條件',
        remark: '備註'
      },
      validate: {
        personName: '用戶名稱不能為空',
        personNameMax: '用戶名稱不能超過64個字符',
        filter: '過濾條件不能為空',
        filterMax: '過濾條件不能超過64個字符',
        remark: '備註不能為空',
        remarkMax: '備註不能超過512個字符',
        blId: '編號不能為空'
      },
      add: {
        title: '新增營銷黑白單',
        success: '新增成功'
      },
      edit: {
        title: '修改營銷黑白單',
        success: '修改成功'
      },
      delete: {
        title: '刪除確認',
        confirm: '確定刪除該營銷黑白單嗎?',
        success: '刪除成功'
      },
      fetchError: '獲取營銷黑白單數據失敗'
    }
  }
}